'use strict';

import {threeJsVariables} from "../../../settings";
import { BufferGeometry, LinearMipMapLinearFilter, Mesh, PlaneGeometry, ShaderMaterial, TextureLoader } from 'three';
import { getWorldData } from '../../controls/orbitControls';
import { isMobile} from '../../../settings';

export function cloudsInit() {
    const vertexShader = `
				varying vec2 vUv;

        void main() {

        vUv = uv;
        gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );

        }
				`;
    const fragmentShader = `
        uniform sampler2D map;

        uniform vec3 fogColor;
        uniform float fogNear;
        uniform float fogFar;

        varying vec2 vUv;

        void main() {

        float depth = gl_FragCoord.z / gl_FragCoord.w;
        float fogFactor = smoothstep( fogNear, fogFar, depth );

        gl_FragColor = texture2D( map, vUv );
        gl_FragColor.w *= pow( gl_FragCoord.z, 20.0 );
        gl_FragColor = mix( gl_FragColor, vec4( fogColor, gl_FragColor.w ), fogFactor );

        }
				`;

    const textureLoader = new TextureLoader();
    const texture = textureLoader.load('./${resourcesFolder}/textures/cloud/cloud10.png');

    texture.magFilter = LinearMipMapLinearFilter;
    texture.minFilter = LinearMipMapLinearFilter;

    const fog = new Fog(0x4584b4,-100,3000);

    const geometry = new BufferGeometry();

    const material = new ShaderMaterial({
        uniforms:{
            map:{type:'t',value: texture},
            fogColor: {type: 'c', value: fog.color},
            fogNear: {type: 'f', value: fog.near},
            fogFar: { type: 'f', value: fog.far },
        },

        vertexShader: vertexShader,
        fragmentShader: fragmentShader,
        depthWrite: false,
        depthTest: false,
        transparent: true,
    });

    const plane = new Mesh(new PlaneGeometry(64,64));

    for (let i=0; i < 300; i++){
        plane.position.x = Math.random() * 1000 - 500;
        plane.position.y = - Math.random() * Math.random() * 200 -15;
        plane.position.z = i * 3.5 ;
        plane.rotation.x = -1.72;
        plane.scale.x = plane.scale.y = plane.scale.z = 2;

        plane.updateMatrix();
        geometry.merge(plane.geometry,plane.matrix);
    }

    const {cameraVector} = getWorldData();
    const mesh = new Mesh(geometry,material);
    mesh.name = 'clouds';
    mesh.position.set(cameraVector.x,cameraVector.y - 150,cameraVector.z - 100);
    mesh.rotation.set(-0.230,0,0);

    threeJsVariables.scene.add(mesh);
    threeJsVariables.renderList.reorder();

}

export function cloudsPositionCorrection () {
    return;
    const clouds = threeJsVariables.scene.getObjectByName('clouds');
    if (clouds){
        const {cameraVector} = getWorldData();
        const posY = isMobile && window.innerWidth > window.innerHeight ? cameraVector.y - 680 : isMobile && window.innerWidth < window.innerHeight ? cameraVector.y - 400 : cameraVector.y - 500;
        clouds.position.set(cameraVector.x,posY,cameraVector.z);
    }
}

export const removeClouds = () => {
    const clouds = threeJsVariables.scene.getObjectByName('clouds');
    if (clouds){
        threeJsVariables.scene.remove(clouds);
    }
}
